module.exports = __webpack_public_path__ + "img/search-bar.2e7d71ff.svg";